import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import breakpoints from '@repo/ui-components/breakpoints';
import SupportArticle from '@repo/ui-components/support-article';
import RelatedSupportArticles from '@repo/ui-components/support-article/RelatedSupportArticles';
import Head from '@repo/ui-components/Head';
import createOpenGraphTagsForSupportSite from '@repo/utils/createOpenGraphTagsForSupportSite';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
  }
`;

const ArticleContainer = styled.div`
  flex-basis: 70%;
`;

const RelatedArticlesContainer = styled.div`
  flex-basis: 30%;
  margin: 1em;
  padding: 1em;
`;

function SupportArticleTemplate({ data }) {
  return (
    <>
      <Head
        title={data?.article?.SEOMetadata?.title}
        description={data?.article?.SEOMetadata?.description}
        linkTags={[
          <link
            key="canonical"
            rel="canonical"
            href={data?.article?.SEOMetadata?.canonicalUrl}
          />,
        ]}
        noIndex={data?.article?.SEOMetadata?.noIndex}
        noFollow={data?.article?.SEOMetadata?.noFollow}
        meta={createOpenGraphTagsForSupportSite({
          title: data?.article?.SEOMetadata?.ogTitle,
          url: data?.article?.SEOMetadata?.ogUrl,
          image: data?.article?.SEOMetadata?.ogImage,
          description: data?.article?.SEOMetadata?.ogDescription,
        })}
      />
      <PageContainer>
        <ArticleContainer>
          <SupportArticle article={data.article} />
        </ArticleContainer>
        <RelatedArticlesContainer>
          <h3>Related Articles</h3>
          {!data?.article?._id.includes('drafts') && (
            <RelatedSupportArticles
              article={data?.article}
              indexName="petsafe-support-articles"
            />
          )}
        </RelatedArticlesContainer>
      </PageContainer>
    </>
  );
}

export const query = graphql`
  query SupportArticle($articleId: String = "") {
    article: sanitySupportArticle(id: { eq: $articleId }) {
      id
      _id
      title
      type
      summary
      body {
        includeTableOfContents
        sections: _rawSupportArticleSections(
          resolveReferences: { maxDepth: 10 }
        )
      }
      slug {
        current
      }
      SEOMetadata {
        canonicalUrl
        description
        noFollow
        noIndex
        title
        ogDescription
        ogTitle
        ogUrl
        ogImage {
          asset {
            id
            url
          }
        }
      }
    }
  }
`;

SupportArticleTemplate.propTypes = {
  data: PropTypes.shape({
    article: PropTypes.shape({
      id: PropTypes.string,
      _id: PropTypes.shape({
        includes: PropTypes.shape({}),
      }),
      SEOMetadata: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        canonicalUrl: PropTypes.string,
        noIndex: PropTypes.bool,
        noFollow: PropTypes.bool,
        ogTitle: PropTypes.string,
        ogUrl: PropTypes.string,
        ogDescription: PropTypes.string,
        ogImage: PropTypes.shape({}),
      }),
    }),
  }),
};

export default SupportArticleTemplate;
